import { getRandomUUID } from "../Token";

/**
 * Custom error class for network-related failures.
 * This is used when a request is made but no response is received from the server.
 * Examples: No internet connection, DNS failure, server is offline.
 */
export class NetworkError extends Error {
  constructor(message) {
    super(message);
    this.name = "NetworkError";
  }
}

/**
 * Custom error class for server-side failures.
 * This is used when the server responds with a 4xx or 5xx status code.
 * Examples: 404 Not Found, 500 Internal Server Error, 401 Unauthorized.
 */
export class ServerError extends Error {
  constructor(message, statusCode, logId, error) {
    super(message);
    this.name = "ServerError";
    this.statusCode = statusCode;
    // logId is the transaction ID.
    this.logId = logId;
    this.errorResponse = error;
  }
}

/**
 * Custom error class for client-side data issues.
 * This is used when an API call succeeds, but the returned data is malformed or
 * missing critical information needed for the application to function.
 * This error is typically thrown in the component's data-fetching logic.
 */
export class DataError extends Error {
  constructor(message) {
    super(message);
    this.name = "DataError";
    // This is a true client-side error, so we generate a unique ID.
    this.logId = getRandomUUID();
  }
}

/**
 * NEW: Error class for connection failures while the client is online
 * (e.g., DNS error, server not running service).
 */
export class ConnectionRefusedError extends Error {
  constructor(message, logId) {
    super(message);
    this.name = "ConnectionRefusedError";
    this.logId = logId;
  }
}
